import { ActionLink } from '@cian/ui-kit';
import clsx from 'clsx';
import * as React from 'react';

import * as styles from './FullPriceEntry.css';

interface IFullPriceEntryProps {
  onClick: React.MouseEventHandler;
  isMutedText?: boolean;
}

export const FullPriceEntry: React.FC<IFullPriceEntryProps> = ({ onClick, isMutedText }) => {
  return (
    <div className={clsx(styles['container'], { [styles['muted']]: isMutedText })}>
      <ActionLink onClick={onClick} fontSize="M" fontWeight="bold" data-testid="FullPriceEntry" color="current_color">
        При 100% оплате
      </ActionLink>
    </div>
  );
};
